import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import AdminDashboard from "@/components/AdminDashboard";
import LegalPage from "@/components/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/waitlist" replace />} />
          <Route path="/waitlist" element={<LandingPage />} />
          <Route path="/admin/waitlist" element={<AdminDashboard />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
